// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/assignees.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/assignees.proto.
 */
export const file_pull_requests_v1_assignees: GenFile = /*@__PURE__*/
  fileDesc("CiBwdWxsX3JlcXVlc3RzL3YxL2Fzc2lnbmVlcy5wcm90bxIXZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEiSQoRQXNzaWduZWVzUmVzcG9uc2USNAoJYXNzaWduZWVzGAEgAygLMiEuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuQXNzaWduZWUiQQoIQXNzaWduZWUSCgoCaWQYASABKAMSFQoNZGlzcGxheV9sb2dpbhgCIAEoCRISCgphdmF0YXJfdXJsGAMgASgJYgZwcm90bzM");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/assignees
 *
 * Defined by PullRequests::PageData::SharedController#assignees.
 *
 * @generated from message github.pull_requests.v1.AssigneesResponse
 */
export type AssigneesResponse = Message<"github.pull_requests.v1.AssigneesResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.Assignee assignees = 1;
   */
  assignees: Assignee[];
};

/**
 * Describes the message github.pull_requests.v1.AssigneesResponse.
 * Use `create(AssigneesResponseSchema)` to create a new message.
 */
export const AssigneesResponseSchema: GenMessage<AssigneesResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_assignees, 0);

/**
 * @generated from message github.pull_requests.v1.Assignee
 */
export type Assignee = Message<"github.pull_requests.v1.Assignee"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.pull_requests.v1.Assignee.
 * Use `create(AssigneeSchema)` to create a new message.
 */
export const AssigneeSchema: GenMessage<Assignee> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_assignees, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(AssigneesResponseSchema, "38b1b84f7a6d")
registerSchemaHash(AssigneeSchema, "bc8a11050502")
